"use strict";

class DeveloperARMSDetailsController {

    constructor($scope, $window, $parse, $filter, $timeout, SSHttpService, SSAppService, SSAwsService, SSUtilService, SSConfirmationService, SSAlertService, SSDateService, OTPService, SSConfigService, SSUserService, Upload) {
        const self = this;

        self.$scope = $scope;
        self.$window = $window;
        self.$parse = $parse;
        self.$filter = $filter;
        self.$timeout = $timeout;

        self.SSHttpService = SSHttpService;
        self.SSAppService = SSAppService;
        self.SSAwsService = SSAwsService;
        self.SSUtilService = SSUtilService;
        self.SSConfirmationService = SSConfirmationService;
        self.SSAlertService = SSAlertService;
        self.SSDateService = SSDateService;
        self.OTPService = OTPService;
        self.SSConfigService = SSConfigService;
        self.SSUserService = SSUserService;
        self.Upload = Upload;

        self.data = SHOWSUITE.data;
        self.property = SHOWSUITE.data.property;

        self.selected_units_count = 0;

         self.PROPERTY_TYPE_LANDED = SHOWSUITE.PROPERTY_TYPE_LANDED;

        self.PROPERTY_DOCUMENT_FORMAT_PDF = SHOWSUITE.PROPERTY_DOCUMENT_FORMAT_PDF;
        self.ASSET_MODEL_PROPERTY_DOCUMENT = SHOWSUITE.ASSET_MODEL_PROPERTY_DOCUMENT;
        self.ASSET_MODEL_PROPERTY_CONSTRUCTION_STATUS = SHOWSUITE.ASSET_MODEL_PROPERTY_CONSTRUCTION_STATUS;
        self.ASSET_MODEL_PAYMENT_SERVING_LETTER = SHOWSUITE.ASSET_MODEL_PAYMENT_SERVING_LETTER;

        self.UNIT_STATUS_DRAFT = SHOWSUITE.UNIT_STATUS_DRAFT;
        self.UNIT_STATUS_LISTED = SHOWSUITE.UNIT_STATUS_LISTED;
        self.UNIT_STATUS_RESERVED = SHOWSUITE.UNIT_STATUS_RESERVED;
        self.UNIT_STATUS_BOOKED = SHOWSUITE.UNIT_STATUS_BOOKED;
        self.UNIT_STATUS_SOLD = SHOWSUITE.UNIT_STATUS_SOLD;
        self.UNIT_STATUS_SPECIAL_RESERVED = SHOWSUITE.UNIT_STATUS_SPECIAL_RESERVED;

        // Property Status
        self.PROPERTY_STATUS_DRAFT = SHOWSUITE.PROPERTY_STATUS_DRAFT; // Just Created
        self.PROPERTY_STATUS_REVIEW = SHOWSUITE.PROPERTY_STATUS_REVIEW; // Submitted for Review
        self.PROPERTY_STATUS_APPROVED = SHOWSUITE.PROPERTY_STATUS_APPROVED; // Approved by the Showsuite Admin
        self.PROPERTY_STATUS_REJECTED = SHOWSUITE.PROPERTY_STATUS_REJECTED; // Rejected by the Showsuite Admin
        self.PROPERTY_STATUS_LISTED = SHOWSUITE.PROPERTY_STATUS_LISTED; // Listed on portal and publicly visible

        self.ARMS_CERTIFICATE_STATUS_DRAFT = SHOWSUITE.ARMS_CERTIFICATE_STATUS_DRAFT;
        self.ARMS_CERTIFICATE_STATUS_SUBMITTED = SHOWSUITE.ARMS_CERTIFICATE_STATUS_SUBMITTED;
        self.ARMS_CERTIFICATE_STATUS_SERVED = SHOWSUITE.ARMS_CERTIFICATE_STATUS_SERVED;

        self.ARMS_UNIT_STATUS_PENDING = SHOWSUITE.ARMS_UNIT_STATUS_PENDING;
        self.ARMS_UNIT_STATUS_SERVED = SHOWSUITE.ARMS_UNIT_STATUS_SERVED;

        self.PAYMENT_TYPE_03_FOUNDATION = SHOWSUITE.PAYMENT_TYPE_03_FOUNDATION;
        self.PAYMENT_TYPE_04_CONCRETE_FRAMEWORK = SHOWSUITE.PAYMENT_TYPE_04_CONCRETE_FRAMEWORK;
        self.PAYMENT_TYPE_05_BRICK_WALLS = SHOWSUITE.PAYMENT_TYPE_05_BRICK_WALLS;
        self.PAYMENT_TYPE_06_CEILING = SHOWSUITE.PAYMENT_TYPE_06_CEILING;
        self.PAYMENT_TYPE_07_INTERNAL_WORKS_1 = SHOWSUITE.PAYMENT_TYPE_07_INTERNAL_WORKS_1;
        self.PAYMENT_TYPE_08_INTERNAL_WORKS_2 = SHOWSUITE.PAYMENT_TYPE_08_INTERNAL_WORKS_2;
        self.PAYMENT_TYPE_09_EXTERNAL_WORKS = SHOWSUITE.PAYMENT_TYPE_09_EXTERNAL_WORKS;
        self.PAYMENT_TYPE_10_NOTICE_OF_VACANT_POSSESSION = SHOWSUITE.PAYMENT_TYPE_10_NOTICE_OF_VACANT_POSSESSION;
        self.PAYMENT_TYPE_11_CSC = SHOWSUITE.PAYMENT_TYPE_11_CSC;
        self.PAYMENT_TYPE_12_DLP = SHOWSUITE.PAYMENT_TYPE_12_DLP;
        self.PAYMENT_TYPE_13_COMPLETION = SHOWSUITE.PAYMENT_TYPE_13_COMPLETION;

        if (self.SSUserService.isDeveloper()) {
            self.init();
        }
    }

    init() {
        const self = this;

        self.LOADING = true;

        self.DETAILS_VIEW_MODE = true;
        self.DETAILS_EDIT_MODE = false;
        self.SERVE_MODE = false;
        self.CREATE_MODE = true;

        // WEB-3624: ARMS certificates Excel import (parse → preview → import)
        self.IMPORT_MODE = false;
        self.importFile = null;
        self.importParsed = null;
        self.importResults = null;
        self.importErrorList = [];


        //  ----------------

        self.checked = 0;

        self.checkboxes = {
            checked: false,
            count: 0,
            items: {}
        };

        self.initPaymentClauses();
        self.initCertificateStatuses();
        self.initUnitStatuses();
        self.setPageOptions();

        self.offset = 0;
        self.limit = 10;
        self.selected_units_count = self.limit;

        self.current = 1;
        self.jump_to_page = 1;

        self.pageChanged = function(newPage) {

            var units = null;

            if(self.isSearchApplied()){
                units = self.getFilteredUnits();
            }

            self.loadUnits(newPage, units);
        };

        //  ----------------

        self.propertyCertificates = [];
        self.availableUnits = [];
        // self.payment_plans = [];
        // self.payment_plan_clauses = [];

        self.selected_units_view = false;
        self.selected_units_list = [];
        self.unit_stats = {};

        self.paymentPlans = [];
        self.clauses = [];

        self.getPropertyCertificates();
    }

    initCertificateStatuses(){
        const self = this;

        self.CERTIFICATE_STATUSES = [
            {'id': self.ARMS_CERTIFICATE_STATUS_DRAFT, 'name': 'Draft', 'className': 'text-primary'},
            {'id': self.ARMS_CERTIFICATE_STATUS_SUBMITTED, 'name': 'Submitted', 'className': 'text-success'},
            {'id': self.ARMS_CERTIFICATE_STATUS_SERVED, 'name': 'Served', 'className': 'text-success'}
        ];
    }

    initUnitStatuses() {
        const self = this;

        self.UNIT_STATUSES = [
            {'id': self.UNIT_STATUS_DRAFT, 'name': 'Draft', 'className': 'text-primary'},
            {'id': self.UNIT_STATUS_LISTED, 'name': 'Listed', 'className': 'text-success'},
            {'id': self.UNIT_STATUS_RESERVED, 'name': 'Served', 'className': 'text-success'},
            {'id': self.UNIT_STATUS_BOOKED, 'name': 'Booked', 'className': 'text-success'},
            {'id': self.UNIT_STATUS_SOLD, 'name': 'Sold', 'className': 'text-danger'},
            {'id': self.UNIT_STATUS_SPECIAL_RESERVED, 'name': 'Special Reserved', 'className': 'text-success'}
        ];
    }

    initPaymentClauses(){
        const self = this;

        self.PAYMENT_CLAUSES = [
            {'id': self.PAYMENT_TYPE_03_FOUNDATION, 'name': 'Foundation'},
            {'id': self.PAYMENT_TYPE_04_CONCRETE_FRAMEWORK, 'name': 'RC Frames'},
            {'id': self.PAYMENT_TYPE_05_BRICK_WALLS, 'name': 'Brick Walls'},
            {'id': self.PAYMENT_TYPE_06_CEILING, 'name': 'Ceiling/R'},
            {'id': self.PAYMENT_TYPE_07_INTERNAL_WORKS_1, 'name': 'Bidg M&E'},
            {'id': self.PAYMENT_TYPE_08_INTERNAL_WORKS_2, 'name': 'Electrical & Sanitary Equipment etc.'},
            {'id': self.PAYMENT_TYPE_09_EXTERNAL_WORKS, 'name': 'Ext Works'},
            {'id': self.PAYMENT_TYPE_10_NOTICE_OF_VACANT_POSSESSION, 'name': 'TOP'},
            {'id': self.PAYMENT_TYPE_11_CSC, 'name': 'CSC'},
            {'id': self.PAYMENT_TYPE_12_DLP, 'name': 'DLP'},
            {'id': self.PAYMENT_TYPE_13_COMPLETION, 'name': 'S&P Completion'},
        ];
    }

    getPropertyCertificates() {
        const self = this;

        if(!self.property){
            console.log("ERROR: Property not found");
            return;
        }

        let url = 'sec/developer/arms/' + self.property.id;
        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            if(response.data && response.data.property_construction_statuses){
                self.propertyCertificates = response.data.property_construction_statuses;
                self.applyFilters();
            }

            self.getUnits(self.property.id);
            self.LOADING = false;
        });
    }

    // getPropertyCertificates() {
    //     const self = this;
    //
    //     if(!self.property){
    //         console.log("ERROR: Property not found");
    //         return;
    //     }
    //
    //     let url = 'sec/developer/arms/' + self.property.id;
    //     loading(true);
    //     self.SSHttpService.getAPIRequest(url).then(function (response) {
    //         loading(false);
    //         if (response instanceof Error) {
    //             self.SSAlertService.parseAndDisplayError(response);
    //             return;
    //         }
    //
    //         if(response.data && response.data.property_construction_statuses){
    //             self.propertyCertificates = response.data.property_construction_statuses;
    //         }
    //
    //         self.getUnits(self.property.id);
    //         self.getPaymentClauses();
    //
    //         self.LOADING = false;
    //     });
    // }
    //
    // getPaymentClauses(){
    //     const self = this;
    //
    //     if(!self.property){
    //         console.log("ERROR: Property not found");
    //         return;
    //     }
    //
    //     let url = 'sec/developer/properties/' + self.property.id + '/payment-plans';
    //     let params = {
    //         include: 'payment_plan_clauses'
    //     };
    //
    //     loading(true);
    //     self.SSHttpService.getAPIRequest(url, params).then(function (response) {
    //         loading(false);
    //         if (response instanceof Error) {
    //             self.SSAlertService.parseAndDisplayError(response);
    //             return;
    //         }
    //
    //         if(response.data && response.data.payment_plans){
    //             self.payment_plans = response.data.payment_plans;
    //
    //             $.each(self.payment_plans, function(index, plan){
    //                 $.each(plan.payment_plan_clauses, function(j, clause){
    //                     self.payment_plan_clauses.push(clause);
    //                 });
    //                 if(plan.is_default == 1){
    //                     self.PAYMENT_CLAUSES = plan.payment_plan_clauses;
    //                 }
    //             });
    //
    //             $.each(self.propertyCertificates, function(index, data){
    //                 data.certificate["clause_name"] = self.getPaymentClauseName(data.certificate.payment_plan_clause_id);
    //             });
    //         }
    //     });
    // }
    //
    // getPaymentPlanByClauseId(clause_id){
    //     const self = this;
    //
    //     let payment_plan = null;
    //     if(!clause_id){
    //         return payment_plan;
    //     }
    //
    //     try{
    //         $.each(self.payment_plans, function(index, plan){
    //             let clause = plan.payment_plan_clauses.find(x => x.id == clause_id);
    //             // payment_plan = self.payment_plans.find(x => x.id == clause_id);
    //             if(clause){
    //                 payment_plan = plan;
    //                 return;
    //             }
    //         });
    //     }
    //     catch(ex){
    //         console.log(ex);
    //     }
    //
    //     return payment_plan;
    // }
    //
    // getPaymentClauseName(id){
    //     const self = this;
    //
    //     let name = '--';
    //     if(!id){
    //         return name;
    //     }
    //
    //     try{
    //         let clause = self.payment_plan_clauses.find(x => x.id == id);
    //         if(clause){
    //             name = clause.name;
    //         }
    //     }
    //     catch(ex){
    //         console.log(ex);
    //     }
    //
    //     return name;
    // }

    viewServingLetter(certificate_id){
        const self = this;

        if(!certificate_id){
            return;
        }

        loading(true);
        self.getPresignedUrl(
            self.ASSET_MODEL_PROPERTY_CONSTRUCTION_STATUS,
            certificate_id,
            function (presignedUrl) {
                loading(false);
                if(presignedUrl){
                    window.open(presignedUrl, '_blank');
                }
            }
        );
    }

    getPresignedUrl(model, id, callback) {
        const self = this;

        let url = 'sec/assets/presigned-url';
        let params = {
            'model': model,
            'id': id
        };

        //loading(true);
        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            //loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            if (callback) {
                callback(response.data.presigned_url);
            }
        });
    }

    //-------------------------------------------

    getUnits(property_id) {
        const self = this;

        if (!property_id)
            return;

        self.stacks = [];
        self.units = [];
        self.units_master = [];
        self.edited_units = [];

        let url = 'sec/developer/properties/' + property_id + '/units';
        let params = {
            offset: 0,
            limit: 9900, // Consider max value
            include: 'is_sale_exercised',
        };
        loading(true);
        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.stacks = response.data.stacks;
            let units = angular.copy(response.data.property_units);
            units = self.SSUtilService.getSortedUnits(units, false, 'named_id');
            self.property_units = angular.copy(units) ; // All units for that property
            self.units_master = angular.copy(self.property_units);
            self.availableUnits = angular.copy(self.property_units);

            jQuery.each(self.property_units, function(i, unit) {
                self.checkboxes.items[unit.id] = false; // Reset user selection
                self.formatUnitData(unit);
            });

            self.getPaymentPlans();
        });
    }

    // CLIENT SIDE PAGINATION
    loadUnits(page, units) {
        const self = this;

        if (page) {
            self.offset = (page * self.limit) - self.limit;
            self.current = page;
            self.jump_to_page = page;
        }

        if (units == null) { // == works for null and undefined
            units = self.units_master;
        }

        self.count = units.length;
        self.units = units.slice(self.offset, self.limit + self.offset);

        // SET 'CURRENT SELECTED UNITS' COUNT
        if (parseInt(self.limit) < parseInt(self.units.length)) {
            self.selected_units_count = self.limit;
        } else {
            self.selected_units_count = self.units.length;
        }

        if (self.count === 0) {
            return;
        }

        // SET TOTAL PAGES ARRAY FOR 'JUMP TO' FEATURE
        let total_pages = Math.ceil(self.count / self.limit);
        self.setTotalPagesOptions(total_pages);
    }

    saveSelectedUnits(status, type){
        const self = this;
        if(self.checked > 0){
            self.searchFilter = "";
            if(type === 'saved_certificate'){
                self.savePropertyCertificate(status);
            }else{
                self.saveServedNoticeCertificate(status);
            }
        }
        else{
            self.SSAlertService.danger("Error!", "Please select units to proceed.");
        }
    }

    proceedUnitSelection() {
        const self = this;

        if (self.checked > 0) {

            self.certificateParams.serving_date = null;
            self.certificateErrors = {};

            // Check if units are selected and show the popup to add 'Serving Date' and 'Letter'
            $('#updateCertificateModal').modal('show');

            // Disable future date selection. The instance is created by the "datepicker"
            // directive at page load; jQuery UI ignores a second .datepicker({...}) init
            // on an attached input, so the option must be set through the 'option' API.
            $('#serving_date').datepicker('option', 'maxDate', new Date());
        } else {
            self.SSAlertService.danger("Error!", "Please select units to proceed.");
        }
    }

    formatUnitData(unit) {
        const self = this;

        unit.formatted_unit_no = self.SSUtilService.getFullUnitNumber(unit);
        unit.formatted_category = self.SSConfigService.getUnitCategoryName(unit.category);
        unit.formatted_type = self.SSConfigService.getUnitTypeName(unit.type);
        unit.formatted_status = self.SSConfigService.getUnitStatusName(unit.status);
        unit.formatted_price_type = self.SSConfigService.getUnitPriceTypeName(unit.price_type);
        unit.formatted_floor_plan_type = unit.floor_plan ? unit.floor_plan : '';
        unit.actual_price = unit.price;

        if (unit.status === self.UNIT_STATUS_SOLD) {
            unit.sale_status = unit.is_sale_exercised ? 'Sold - Exercised' : 'Sold - Pending Exercise';
        } else {
            unit.sale_status = 'Listed';
        }

        let stack = self.findStack(unit.stack_id);
        if (stack) {
            unit.block_no = stack.block_no;
            unit.stack_name = stack.name;
        }

        return unit;
    }

    findStack(stackId) {
        const self = this;

        let stack = null;

        jQuery.each(self.stacks, function (i, _stack) {
            if (stackId == _stack.id) {
                stack = _stack;
                return false;
            }
        });

        return stack;
    }

    applySearch(){
        const self = this;

        let units = self.units_master;
        let page = 0;

        if(self.isSearchApplied()){
            self.offset = 0;
            page = 1;

            units = self.getFilteredUnits();
        }

        self.loadUnits(page ? page : undefined, units); // undefined is to differentiate from 0

        // Re-Assign CheckAll filter
        // self.toggleCheckAll();
    }

    isSearchApplied() {
        const self = this;

        if (!self.searchText.block_no
            && !self.searchText.floor_no
            && !self.searchText.unit_no
            && !self.searchText.category
            && !self.searchText.floor_plan_type
            && !self.searchText.name
            && !self.searchText.price_type
            && !self.searchText.sale_status
            && !self.searchText.serving_status
        ) {
            return false;
        } else {
            return true;
        }
    }

    getFilteredUnits() {
        const self = this;

        let units = [];

        jQuery.each(self.units_master, function (index, unit) {
            if (self.searchText.block_no && !(unit.block_no && unit.block_no.toString().includes(self.searchText.block_no))) {
                return;
            }
            if (self.searchText.floor_no && !(unit.floor_no && unit.floor_no.toString().includes(self.searchText.floor_no))) {
                return;
            }
            if (self.searchText.unit_no && !(unit.unit_no && unit.unit_no.toString().includes(self.searchText.unit_no))) {
                return;
            }
            if (self.searchText.category && !(unit.formatted_category && unit.formatted_category.trim().toLowerCase().includes(self.searchText.category.trim().toLowerCase()))) {
                return;
            }
            if (self.searchText.floor_plan_type && !(unit.formatted_floor_plan_type && unit.formatted_floor_plan_type.trim().toLowerCase().includes(self.searchText.floor_plan_type.trim().toLowerCase()))) {
                return;
            }
            if (self.searchText.name && !(unit.name && unit.name.trim().toLowerCase().includes(self.searchText.name.trim().toLowerCase()))) {
                return;
            }
            if (self.searchText.sale_status && !(unit.sale_status && unit.sale_status.trim().toLowerCase().includes(self.searchText.sale_status.trim().toLowerCase()))) {
                return;
            }
            if (self.searchText.serving_status_name && !(unit.serving_status_name && unit.serving_status_name.trim().toLowerCase().includes(self.searchText.serving_status_name.trim().toLowerCase()))) {
                return;
            }

            units.push(unit);
        });

        return units;
    }

    getSelectedUnitsCount(obj){
        const self = this;

        if(!obj){
            return;
        }

        if(obj.unit_ids){
            try{
                let _unit_ids = obj.unit_ids;
                if(_unit_ids.startsWith(',')){
                    // When you use the replace method with a string rather than an RE, it just replaces the first match.
                    _unit_ids = _unit_ids.replace(',', '');
                }
                let unit_ids = _unit_ids.split(',');
                if(unit_ids.length > 0){
                    return unit_ids.length;
                }
            }
            catch(ex){
                console.log(ex);
            }
        }
        else{
            return '--';
        }
    }

    /**
     * Select or clear every (filtered) unit row to match the Select All checkbox.
     *
     * Must be wired in the view via ng-model="ctrl.checkAll" + ng-change — never ng-click:
     * on checkboxes ng-click fires before ngModel writes the new state, so self.checkAll
     * would still hold the previous value and the toggle behaves inverted (WEB-3555).
     *
     * @returns {void}
     */
    toggleCheckAll(){
        const self = this;

        self.checked = 0;
        // Uncheck all to apply new changes
        jQuery.each(self.units_master, function (index, unit) {
            self.checkboxes.items[unit.id] = false;
            self.edited_status = "";
        });

        let units = self.units_master;

        if(self.isSearchApplied()){
            units = self.getFilteredUnits();
        }

        if(self.checkAll){
            // All units checked
            jQuery.each(units, function (index, unit) {
                //if (unit.action_allowed) {
                    self.checkboxes.items[unit.id] = true;
                    self.checked += 1;
                //}
            });
        }
    }

    checkedAlert(unit) {
        const self = this;

        if(self.checkboxes.items[unit.id] == false){
            self.checkboxes.items[unit.id] == true;
            self.checked -= 1;
        }
        else if(self.checkboxes.items[unit.id] == true){
            self.checkboxes.items[unit.id] == false;
            self.checked += 1;
        }
    }

    setPageOptions(){
        const self = this;

        self.PAGE_OPTIONS = [
            {
                id: 5,
                name: '5 Rows'
            },
            {
                id: 10,
                name: '10 Rows'
            },
            {
                id: 20,
                name: '20 Rows'
            },
            {
                id: 30,
                name: '30 Rows'
            },
            {
                id: 40,
                name: '40 Rows'
            },
            {
                id: 50,
                name: '50 Rows'
            },
            {
                id: 100,
                name: '100 Rows'
            },
            {
                id: 200,
                name: '200 Rows'
            },
            {
                id: 400,
                name: '400 Rows'
            }
        ];
    }

    setTotalPagesOptions(TOTAL_PAGES){
        const self = this;

        self.TOTAL_PAGES_OPTIONS = [];

        for(var index = 0; index < TOTAL_PAGES; index++){
            self.TOTAL_PAGES_OPTIONS.push({id: index + 1, name: 'PAGE ' + (index + 1).toString() });
        }
    }

    //---------------------------------

    updateCertificate(data){
        const self = this;

        self.certificateParams = {};
        self.certificateErrors = {};
        self.searchText = {};

        self.SHOW_STACKVIEW_TOP_BUTTONS = false;
        self.DETAILS_VIEW_MODE = false;
        self.DETAILS_EDIT_MODE = true;
        self.SERVE_MODE = false;
        self.CREATE_MODE = true;

        self.checkAll = false;
        self.current = 1;
        self.jump_to_page = 1;

        self.units_master = angular.copy(self.property_units);

        // Remove units of previous record
        self.checked = 0;
        self.checkboxes = {
            checked: false,
            count: 0,
            items: {}
        };

        if(data && data.certificate){
            self.CREATE_MODE = false;

            self.certificateParams = angular.copy(data.certificate);

            if(self.certificateParams.certificate_date){
                self.certificateParams.certificate_date = moment(data.certificate.certificate_date, "YYYY-MM-DD").format("DD/MM/YYYY");
            }

            if (self.certificateParams.certificate_file_uri) {
                let extension = self.certificateParams.certificate_file_uri.substr((self.certificateParams.certificate_file_uri.lastIndexOf('.') +1));

                if(extension == 'pdf'){
                    self.certificateParams.file_uri = '/images/pdf-placeholder.png';
                }
                else{
                   self.getPresignedUrl(
                        self.ASSET_MODEL_PROPERTY_CONSTRUCTION_STATUS,
                        self.certificateParams.id,
                        function (presignedUrl) {
                            self.certificateParams.file_uri = presignedUrl;
                        }
                    ); 
                }
            }

            let unit_ids = $.map(data.units, function(unit, index){
              return unit.unit_id;
            });

            self.checkMarkSelectedUnits(unit_ids, data.units);
        }

        self.units_master_bakup = angular.copy(self.units_master);
        self.filterPaymentTypeUnits();
    }

    showCertificateServeView(data) {
        const self = this;

        self.certificateParams = {};
        self.certificateErrors = {};
        self.searchText = {};

        self.DETAILS_VIEW_MODE = false;
        self.DETAILS_EDIT_MODE = false;
        self.SERVE_MODE = true;
        self.show_top_filter = false;

        self.checkAll = false;
        self.current = 1;
        self.jump_to_page = 1;

        // Remove units of previous record
        self.checked = 0;
        self.checkboxes = {
            checked: false,
            count: 0,
            items: {}
        };



        self.certificateParams.architect_certificate_id = data.certificate.id;
        self.certificateParams.certificate_number = data.certificate.certificate_number;
        self.certificateParams.name = data.certificate.name;
        self.certificateParams.property_name = self.property.name;
        self.certificateParams.payment_type_name = self.getClauseName(data.certificate.payment_type);

        self.units_master = [];
        $.each(data.units, function (index, certificateUnit) {
            let unit = angular.copy(self.getUnit(certificateUnit.unit_id));
            unit.serving_status= certificateUnit.status;
            unit.serving_status_name = certificateUnit.status === self.ARMS_UNIT_STATUS_SERVED ? 'Served' : 'Pending';
            unit.action_allowed = self.isServingActionAllowed(unit);
            self.formatUnitData(unit);

            self.units_master.push(unit);
        });

        self.searchText.sale_status = 'sold';
        self.show_top_filter = true;

        self.count = self.units_master.length; // Total units count for pagination

        self.applySearch();
    }

    getUnit(unitId) {
        const self = this;

        let unit = null;
        $.each(self.property_units, function(i, _unit){
            if (_unit.id === unitId) {
                unit = _unit;
                return false;
            }
        });

        return unit;
    }

    isServingActionAllowed(unit) {
        const self = this;

        return unit
            && unit.is_sale_exercised
            && unit.serving_status !== self.ARMS_UNIT_STATUS_SERVED;
    }

    checkMarkSelectedUnits(unit_ids, certificate_units){
        const self = this;

        if(!unit_ids){
            return;
        }

        try{
            if(unit_ids && unit_ids.length > 0){

                self.checked = 0;
                self.checkboxes = {
                    checked: false,
                    count: 0,
                    items: {}
                };

                $.each(self.units_master, function(index, unit){

                    if($.inArray(unit.id, unit_ids) > -1){
                        self.checkboxes.items[unit.id] = true;
                        self.checked += 1;
                    }

                    let selected_unit = certificate_units.find(x => x.unit_id == unit.id);

                    if(selected_unit && selected_unit.status == self.ARMS_UNIT_STATUS_SERVED){
                        unit.serving_status = 'Served';
                    }
                    else{
                        unit.serving_status = 'Pending';
                    }

                });
            }
        }
        catch(ex){
            console.log(ex);
        }
    }

    viewSelectedUnits(units){
        const self = this;

        if(!units){
            return;
        }

        self.selected_units_list = [];

        let unsold_units = 0;
        let served_units = 0;
        let unserved_units = 0;

        $.each(units, function(index, obj){
            let unit = self.availableUnits.find(x => x.id == obj.unit_id);

            if(unit){

                if(unit.status != self.UNIT_STATUS_SOLD){
                    unsold_units += 1;
                }

                unit["block_no"] = self.getStackName(unit);
                if(obj.status == self.ARMS_UNIT_STATUS_SERVED){
                    served_units += 1;
                    unit["certificate_status"] = 'Served'
                }
                else{
                    unserved_units += 1;
                    unit["certificate_status"] = 'Pending'
                }
                self.selected_units_list.push(unit);
            }
        });

        self.unit_stats["unsold"] = unsold_units;
        self.unit_stats["served"] = served_units;
        self.unit_stats["unserved"] = unserved_units;
        self.unit_stats["total"] = self.availableUnits.length;

        self.selected_units_view = true;
        $("#unitsListView").modal('show');
        $('#unitsListView').find('.modal-dialog').css('max-width', '590px');
    }

    getStackName(unit){
        const self = this;

        let stack_name = "--";

        if(!unit){
            return stack_name;
        }

        let stack = self.stacks.find(x => x.id == unit.stack_id);
        if(stack){
            stack_name = stack.name;
        }

        return stack_name;
    }

    cancelSelectedUnitsView(){
        const self = this;

        self.selected_units_view = false;
        if ($('#unitsListView').is(':visible')) $('#unitsListView').modal('hide');
    }

    savePropertyCertificate(status){
        const self = this;

        self.certificateErrors = {};
        if (!self.isValidCertificateInput()) {
            return;
        }

        let url = 'sec/developer/arms';
        let params = angular.copy(self.certificateParams);
        params.status = status;

        // Set payment typw based on selected payment plan clause
        if (params.payment_plan_clause_id && self.clauses && self.clauses.length) {
            let clause = self.clauses.find(c => c.id === params.payment_plan_clause_id);
            params.payment_type = clause? clause.payment_type : null;
        }

        if(params.certificate_date){
            params.certificate_date = self.SSDateService.formateWithTimeAsNoon(params.certificate_date);
        }

        if(self.DETAILS_EDIT_MODE && self.checked > 0){

            let unit_ids = '';

            $.each(self.units_master, function (index, unit) {
                if (self.checkboxes.items[unit.id] == true) {
                    if(index == 0){
                        unit_ids += unit.id;
                    }
                    else{
                        unit_ids += ',' + unit.id;
                    }
                }
            });
            params.unit_ids = unit_ids;
        }

        let responseHandler = function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            let message = "Certificate " + (self.certificateParams.id ? 'updated' : 'added') + " successfully.";
            self.SSAlertService.success("Success!", message);

            self.getPropertyCertificates();

            self.DETAILS_VIEW_MODE = true;
            self.DETAILS_EDIT_MODE = false;
            self.SERVE_MODE = false;
            self.selectedUnits = [];
        };

        loading(true);
        if (self.certificateParams.id) {
            url += '/' + self.certificateParams.id;
            self.SSHttpService.putAPIRequest(url, params).then(responseHandler);
        } else {
            params.property_id = self.property.id;
            self.SSHttpService.postAPIRequest(url, params).then(responseHandler);
        }
    }

    saveServedNoticeCertificate(status){
        const self = this;

        self.certificateErrors = {};
        if (!self.isValidServedNoticeInput()) {
            return;
        }

        let url = 'sec/developer/arms/serve-units';
        let params = angular.copy(self.certificateParams);
        params.status = status;

        if(params.certificate_date){
            params.certificate_date = self.SSDateService.formateWithTimeAsNoon(params.certificate_date);
        }
        if (params.serving_date) {
            params.serving_date = self.SSDateService.formateWithTimeAsNoon(params.serving_date);
        }

        if(self.SERVE_MODE && self.checked > 0){

            let unit_ids = '';

            $.each(self.units_master, function (index, unit) {
                if (self.checkboxes.items[unit.id] == true) {
                    if(index == 0){
                        unit_ids += unit.id;
                    }
                    else{
                        unit_ids += ',' + unit.id;
                    }
                }
            });
            params.unit_ids = unit_ids;
        }

        let responseHandler = function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            $('#updateCertificateModal').modal('hide');
            let message = "Selected Units Served Noticed Successfully.";
            self.SSAlertService.success("Success!", message);

            self.getPropertyCertificates();

            self.DETAILS_VIEW_MODE = true;
            self.DETAILS_EDIT_MODE = false;
            self.SERVE_MODE = false;
            self.selectedUnits = [];
        };

        loading(true);
        if (self.certificateParams.id) {
            url += '/' + self.certificateParams.id;
            self.SSHttpService.putAPIRequest(url, params).then(responseHandler);
        } else {
            params.property_id = self.property.id;
            self.SSHttpService.postAPIRequest(url, params).then(responseHandler);
        }
    }

    isValidServedNoticeInput() {
        const self = this;

        let isValid = true;

        if (!self.certificateParams.serving_date) {
            self.certificateErrors.serving_date = 'This field is required.';
            isValid = false;
        }
        return isValid;
    }

    isValidCertificateInput() {
        const self = this;

        let isValid = true;

        if (!self.certificateParams.name) {
            self.certificateErrors.name = 'The certificate name field is required.';
            isValid = false;
        }
        if (!self.certificateParams.certificate_number) {
            self.certificateErrors.certificate_number = 'The certificate number field is required.';
            isValid = false;
        }
        if (!self.certificateParams.certificate_date) {
            self.certificateErrors.certificate_date = 'The certificate date field is required.';
            isValid = false;
        }
        if (!self.certificateParams.payment_plan_clause_id) {
            self.certificateErrors.payment_plan_clause_id = 'The payment plan clause field is required.';
            isValid = false;
        }
        return isValid;
    }

    formatUtcToLocalDate(date){
        const self = this;

        let localeDate = moment(moment(date, "YYYY-MM-DD")).format("DD/MM/YYYY");

        return localeDate;
    }

    //-------------------------------------------

    uploadCertificate(files, certificate_document) {
        const self = this;

        self.certificateErrors.certificate_file_uri = "";

        if (!files || files.length < 1) return;
        let file = files[0];
        let format_type = null;

        if (file.type.indexOf("application/pdf") !== -1) {
            format_type = self.PROPERTY_DOCUMENT_FORMAT_PDF;
        } else if (file.type.indexOf("image") !== -1) {
            format_type = self.PROPERTY_DOCUMENT_FORMAT_IMG;
        } else {
            self.certificateErrors.certificate_file_uri = 'Please upload PDF or image file only';
            return;
        }

        // Show 'image' preview
        if (format_type == self.PROPERTY_DOCUMENT_FORMAT_IMG) {
            var reader = new FileReader();
            reader.onload = function (event) {
                certificate_document['file_uri'] = event.target.result;
            }
            // when the file is read it triggers the onload event above.
            reader.readAsDataURL(file);
        } else {
            certificate_document['file_uri'] = '/images/pdf-placeholder.png';
        }

        let policyUrl = 'sec/developer/arms/' + self.property.id + '/s3-policy-document';

        loading(true);
        self.SSAwsService.uploadAPIRequest(file, policyUrl, function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            certificate_document['certificate_file_uri'] = response.config.data.key;
        });
    }

    replaceCertificate(files, documentObj) {
        const self = this;

        self.certificateErrors.certificate_file_uri = "";

        if (!files || files.length < 1) return;
        let file = files[0];
        let format_type = null;

        if (file.type.indexOf("application/pdf") !== -1) {
            format_type = self.PROPERTY_DOCUMENT_FORMAT_PDF;
        } else if (file.type.indexOf("image") !== -1) {
            format_type = self.PROPERTY_DOCUMENT_FORMAT_IMG;
        } else {
            self.certificateErrors.certificate_file_uri = 'Please upload PDF or image file only';
            return;
        }

        let callback = self.uploadCertificate(files, documentObj);

        self.removeCertificate(documentObj, callback);
    }

    removeCertificate(documentObj, callback) {
        const self = this;

        documentObj.certificate_file_uri = null;
        documentObj["show_file_url"] = null;

        callback;
    }

    downloadCertificate(certificate) {
        const self = this;
        console.log('>>>>>>>>>>>>>'+certificate+'<<<<<<<<<<<<');
        if (!certificate
                || !certificate.id
            ) {
                return;
            }

        let url = "sec/developer/arms/"+certificate.id+"/export";
        url = self.SSHttpService.getApiURL(url);

        self.$window.location.href  = url;
        self.SSAlertService.success('Success!', 'Download start shortly');
    }

    deleteCertificate(data){
        const self = this;

        if(!data || !data.certificate){
            return;
        }

        var served_units = 0;

        $.each(data.units, function(index, unit){
            if(unit.status == self.ARMS_UNIT_STATUS_SERVED){
                served_units += 1;
            }
        });

        if(served_units > 0){
            self.SSConfirmationService.getConfirmed(
                'Error',
                'This certificate cannot be deleted as there are ' + served_units + ' unit(s) which are already served.',
                self.SSConfirmationService.TYPE_OK,
                function () {
                    return;
                }
            );
        }
        else{
            self._deleteCertificate(data.certificate);
        }

    }

    _deleteCertificate(certificate){
        const self = this;

        self.SSConfirmationService.getConfirmed(
            'Confirmation!',
            'Are you sure you want to delete this?',
            self.SSConfirmationService.TYPE_DEFAULT,
            function () {
                let url = 'sec/developer/arms/' + certificate.id + '/delete';

                loading(true);
                self.SSHttpService.getAPIRequest(url).then(function (response) {
                    loading(false);
                    if (response instanceof Error) {
                        if(response.code == 409 && response.message){
                            self.SSAlertService.danger("Error!", response.message);
                        }
                        else{
                            self.SSAlertService.parseAndDisplayError(response);
                        }
                        return;
                    }

                    self.SSAlertService.success("Success!", "Certificate removed successfully.");

                    // Remove from local data
                    jQuery.each(self.propertyCertificates, function (i, data) {
                        if (data.certificate.id == certificate.id) {
                            self.propertyCertificates.splice(i, 1);
                            return false;
                        }
                    });
                    self.applyFilters();

                });
            }
        );
    }

    //-------------------------------------------

    uploadServingLetter(files, certificate_document) {
        const self = this;

        self.certificateErrors.serving_letter_uri = "";

        if (!files || files.length < 1) return;
        let file = files[0];
        let format_type = null;

        if (file.type.indexOf("application/pdf") !== -1) {
            format_type = self.PROPERTY_DOCUMENT_FORMAT_PDF;
        } else if (file.type.indexOf("image") !== -1) {
            format_type = self.PROPERTY_DOCUMENT_FORMAT_IMG;
        } else {
            self.certificateErrors.serving_letter_uri = 'Please upload PDF or image file only';
            return;
        }

        let unit_id = Object.keys(self.checkboxes.items)[0];

        let policyUrl = 'sec/lawyer/units/' + unit_id + '/documents/s3-policy-document';

        loading(true);
        self.SSAwsService.uploadAPIRequest(file, policyUrl, function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            certificate_document['serving_letter_uri'] = response.config.data.key;
        });
    }

    replaceServingLetter(files, documentObj) {
        const self = this;

        self.certificateErrors.serving_letter_uri = "";

        if (!files || files.length < 1) return;
        let file = files[0];
        let format_type = null;

        if (file.type.indexOf("application/pdf") !== -1) {
            format_type = self.PROPERTY_DOCUMENT_FORMAT_PDF;
        } else if (file.type.indexOf("image") !== -1) {
            format_type = self.PROPERTY_DOCUMENT_FORMAT_IMG;
        } else {
            self.certificateErrors.serving_letter_uri = 'Please upload PDF or image file only';
            return;
        }

        let callback = self.uploadServingLetter(files, documentObj);

        self.removeServingLetter(documentObj, callback);
    }

    removeServingLetter(documentObj, callback) {
        const self = this;

        documentObj.serving_letter_uri = null;
        documentObj.show_file_url = null;

        if (callback) {
            callback();
        }
    }

    //-------------------------------------------

    toggleStackview(){
        const self = this;

        self.certificateParams = {};
        self.certificateErrors = {};

        self.DETAILS_VIEW_MODE = true;
        self.DETAILS_EDIT_MODE = false;
        self.SERVE_MODE = false;
    }

    //-------------------------------------------

    getCertificateStatusName(certificate) {
        const self = this;

        // Set 'default' value as Draft
        let name = 'Draft';

        let status = self.getCertificateStatus(certificate);
        if (status) {
            name = status.name;
        }

        return name;
    }

    getCertificateStatusClass(certificate){
        const self = this;

        let className = 'text-primary';

        let status = self.getCertificateStatus(certificate);
        if(status){
            className = status.className;
        }

        return className;
    }

    getCertificateStatus(certificate){
        const self = this;

        let status = null;

        if(!certificate){
            return status;
        }

        try{
            status = self.CERTIFICATE_STATUSES.find(x => x.id == certificate.status);
        }
        catch(ex){
            console.log(ex);
        }

        return status;
    }

    getUnitStatusClass(status) {
        const self = this;

        let className = '';

        if (!status) {
            return className;
        }

        try {
            if (status.toLowerCase() === "sold") {
                className = "text-danger";
            }
        } catch (ex) {
            console.log(ex);
        }

        return className;
    }

    getPaymentClauseName(clause_id){
        const self = this;

        let name = '--';

        if(!clause_id){
            return name;
        }

        try{
            let clause = self.PAYMENT_CLAUSES.find(x => x.id == clause_id);
            if(clause){
                name = clause.name;
            }
        }
        catch(ex){
            console.log(ex);
        }

        return name;
    }

    /** WEB-3014 AllGreen : ARMS Restrict the unit selection for same type of clause - START **/
    filterPaymentTypeUnits() {
        const self = this;

        // If payment type not selected, show all units
        if(!self.certificateParams || !self.certificateParams.payment_plan_clause_id) {
            self.loadUnits(1, self.units_master);
            return false;
        }

        self.units_master = angular.copy(self.units_master_bakup); // Reset units on type change

        let selected_clause_payment_type = null;
        if (self.clauses && self.clauses.length) {
            let selected_clause = self.clauses.find(c => c.id === self.certificateParams.payment_plan_clause_id);
            selected_clause_payment_type = selected_clause? selected_clause.payment_type : null;
        }
        let selected_type_certificates = [];
        if (self.certificateParams && self.propertyCertificates && self.propertyCertificates.length
                && selected_clause_payment_type !== self.PAYMENT_TYPE_12_DLP){ //Skip filtering for DLP Payment type
            selected_type_certificates = self.propertyCertificates.filter(c => { // Get certificates where selected payment_type match
                return c.certificate && c.certificate.payment_type
                    && c.certificate.id !== self.certificateParams.id
                    && c.certificate.payment_type === selected_clause_payment_type;
            });

            let selected_type_units = [];
            if(selected_type_certificates && selected_type_certificates.length){
                selected_type_certificates.forEach(certificate => { // Get all unit_ids of filtered certificates
                    if(certificate.units && certificate.units.length){
                        let certificate_unit_id_list = certificate.units.map(u => u.unit_id);
                        selected_type_units.push(...certificate_unit_id_list);
                    }
                })
            }

            if (selected_type_certificates && self.units_master && self.units_master.length){
                self.units_master = self.units_master.filter(u => { // Filter out units already selected for other certificate with same payment type/clause
                    return selected_type_units.indexOf(u.id) === -1;
                })
            }
        }
        self.applyFilters();

        self.count = self.units_master && self.units_master.length ? self.units_master.length : 0; // Total units count for pagination
        self.loadUnits(1, self.units_master);
    }
    /** WEB-3014 AllGreen : ARMS Restrict the unit selection for same type of clause - END **/

    getPaymentPlans(){
        const self = this;

        let url = 'sec/developer/payment-plans';
        let params = {
            include: "payment_plan_clauses"
        };

        loading(true);
        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            if (response.data
                && response.data.payment_plans
                && response.data.payment_plans.length > 0
            ) {
                self.paymentPlans = response.data.payment_plans;
                self.loadDefaultPaymentPlanClauses();
            }
        });
    }

    loadDefaultPaymentPlanClauses(){
        const self = this;

        if (!self.paymentPlans || !self.paymentPlans.length){
            console.warn("No Payment Plans found!");
            return;
        }

        let defaultPaymentPlan = self.paymentPlans.find(p => p.is_default && p.is_active);
        if (defaultPaymentPlan) { // If the default payment plan exists, set its clauses
            self.clauses = defaultPaymentPlan.payment_plan_clauses;
        } else if (self.paymentPlans.find(p => p.is_active)
                && self.paymentPlans.find(p => p.is_active).payment_plan_clauses) { // If no default payment plan exists, set clauses of first payment plan
            console.warn("Default payment plan not found, using first payment plan found as default");
            self.clauses = self.paymentPlans.find(p => p.is_active).payment_plan_clauses;
        }

        if (self.clauses && self.clauses.length) {
            // Filter clauses to show only those that exist in PAYMENT_CLAUSES list
            self.clauses = self.clauses.filter(c => {
                return self.PAYMENT_CLAUSES.find(ps => ps.id === c.payment_type);
            })
        }

        if (self.propertyCertificates && self.propertyCertificates.length
                && self.clauses && self.clauses.length) {
            // Init payment_plan_clause_id if not set against certificate based on payment type
            self.propertyCertificates = self.propertyCertificates.map(certObj => {
                let cert = certObj.certificate || {};
                if (!cert.payment_plan_clause_id && cert.payment_type) {
                    let clause = self.clauses.find(c => c.payment_type === cert.payment_type);
                    cert.payment_plan_clause_id = clause? clause.id : null;
                }

                return certObj;
            })
            self.applyFilters();
        }
    }

    getClauseName(paymentType){
        const self = this;

        let name = "--";
        if (self.clauses && self.clauses.length) {
            let clause = self.clauses.find(c => c.payment_type === paymentType);
            name = clause? clause.name : "--";
        }

        return name;
    }

    /** WEB-3075 DMS ARMS: Add search option to filter the list - Start **/
    applyFilters(){
        const self = this;

        self.filtered_certificates = self.propertyCertificates.filter( obj => {
            let isMatch = true;

            if(self.searchFilter && (
                obj.certificate.name.toLowerCase().indexOf(self.searchFilter.toLowerCase()) === -1 &&
                obj.certificate.certificate_number.toLowerCase().indexOf(self.searchFilter.toLowerCase()) === -1 &&
                self.formatUtcToLocalDate(obj.certificate.certificate_date).match(self.searchFilter) === null &&
                self.getClauseName(obj.certificate.payment_type).toLowerCase().indexOf(self.searchFilter.toLowerCase()) === -1)){
                isMatch = false;
            }
            return isMatch;
        })
    }

    clearFilters(){
        const self = this;

        self.searchFilter = "";
        self.typeFilter = "";
        self.kindFilter = null;
        self.enabledFilter = "";

        self.applyFilters();
    }
    /** WEB-3075 DMS ARMS: Add search option to filter the list - End **/

    /** WEB-3624 DMS ARMS: Bulk-import architect certificates from Excel - Start **/

    // Switch the page into the import panel (parse → preview → import).
    showImportView() {
        const self = this;

        self.resetImportState();

        self.DETAILS_VIEW_MODE = false;
        self.DETAILS_EDIT_MODE = false;
        self.SERVE_MODE = false;
        self.IMPORT_MODE = true;
    }

    // Clear any selected file / parsed preview / result summary.
    resetImportState() {
        const self = this;

        self.importFile = null;
        self.importParsed = null;
        self.importResults = null;
        self.importErrorList = [];
        self.progressUploadingFiles = false;
        self.filesUploadProgress = 0;
    }

    // Leave the import panel and return to the certificate listing.
    cancelImport() {
        const self = this;

        self.resetImportState();

        self.IMPORT_MODE = false;
        self.DETAILS_VIEW_MODE = true;
    }

    // Step 1: upload the Excel and render a preview of the parsed rows.
    parseArmsCertificates() {
        const self = this;

        if (!self.importFile) {
            self.SSAlertService.danger('Error!', 'Please select an Excel file to import.');
            return;
        }
        if (!self.property || !self.property.id) {
            self.SSAlertService.danger('Error!', 'Property not found.');
            return;
        }

        self.importResults = null;
        self.progressUploadingFiles = true;
        self.filesUploadProgress = 0;

        loading(true);
        self.Upload.upload({
            url: self.SSHttpService.getApiURL('sec/developer/import/arms-certificates/parse'),
            method: 'POST',
            data: {
                property_id: self.property.id,
                import_file: self.importFile
            },
            withCredentials: true
        }).then(
            function (response) {
                loading(false);
                self.progressUploadingFiles = false;

                let payload = (response && response.data) ? response.data : {};

                if (payload.code && payload.code !== 200) {
                    self.SSAlertService.parseAndDisplayError(payload);
                    return;
                }

                // WEB-3621 parse endpoint returns { data: { arms_certificates: [...rows] } }.
                let data = payload.data || payload;
                self.importParsed = data;
                self.importParsed.rows = data.arms_certificates || [];
            },
            function (response) {
                loading(false);
                self.progressUploadingFiles = false;
                self.SSAlertService.parseAndDisplayError(response);
            },
            function (evt) {
                if (evt && evt.lengthComputable) {
                    self.filesUploadProgress = parseInt(100.0 * evt.loaded / evt.total);
                }
            }
        );
    }

    // Step 2: execute the import of the parsed rows.
    // Posts directly (no step-up) to mirror the Sales Payment Instruments import; the
    // WEB-3621 backend endpoint does not require 2FA, and the ARMS page has no OTP modal.
    confirmImportArmsCertificates() {
        const self = this;

        if (!self.importParsed || !self.importParsed.rows || !self.importParsed.rows.length) {
            self.SSAlertService.danger('Error!', 'There are no rows to import.');
            return;
        }

        self._importArmsCertificates();
    }

    _importArmsCertificates() {
        const self = this;

        // WEB-3621 import endpoint expects the parsed rows under `arms_certificates`.
        let params = {
            property_id: self.property.id,
            arms_certificates: self.importParsed.rows
        };

        loading(true);
        self.SSHttpService.postAPIRequest('sec/developer/import/arms-certificates', params).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            // WEB-3621 summary: { certificates, serve_calls, units_served, unresolved_units, errors }.
            // `errors` is an object keyed by certificate_number → message; flatten it to a list
            // the preview table can ng-repeat over.
            self.importResults = response.data || {};
            let errs = self.importResults.errors || {};
            self.importErrorList = Object.keys(errs).map(function (certNo) {
                return { certificate_number: certNo, message: errs[certNo] };
            });

            if (self.importErrorList.length) {
                self.SSAlertService.warning('Import completed with errors', 'Some certificates could not be imported. See the errors below.');
            } else {
                self.SSAlertService.success('Success!', 'ARMS certificates import completed.');
            }

            // Refresh the certificate list behind the import panel.
            self.getPropertyCertificates();
        });
    }
    /** WEB-3624 DMS ARMS: Bulk-import architect certificates from Excel - End **/
}

DeveloperARMSDetailsController.$inject = ['$scope', '$window', '$parse', '$filter', '$timeout', 'SSHttpService', 'SSAppService', 'SSAwsService', 'SSUtilService', 'SSConfirmationService', 'SSAlertService', 'SSDateService', 'OTPService', 'SSConfigService', 'SSUserService', 'Upload'];
app.controller('DeveloperARMSDetailsController', DeveloperARMSDetailsController);

app.directive("datepicker", function () {

    function link(scope, element, attrs) {
        // CALL THE "datepicker()" METHOD USING THE "element" OBJECT.
        element.datepicker({
            dateFormat: "dd/mm/yy",
            /**
             * WEB-3555: for inputs inside a fixed container (Bootstrap modal, e.g. Serve
             * Notice), jQuery UI renders the calendar position:fixed but leaves the page
             * scroll offset baked into its `top`, so the calendar opens below the field by
             * exactly the scrolled amount. Re-pin it to the input's viewport position once
             * jQuery UI has finished positioning (same approach as WEB-2834 in
             * lms_dms_util.js). In-page inputs keep jQuery UI's own (correct) positioning.
             */
            beforeShow: function (input, inst) {
                let $input = $(input);
                let inFixedContainer = $input.parents().filter(function () {
                    return $(this).css("position") === "fixed";
                }).length > 0;

                if (!inFixedContainer) {
                    return;
                }

                setTimeout(function () {
                    inst.dpDiv.css({
                        top: $input.offset().top - $(document).scrollTop() + $input.outerHeight(),
                        left: $input.offset().left - $(document).scrollLeft()
                    });
                }, 0);
            }
        });
    }

    return {
        require: 'ngModel',
        link: link
    };
});

app.directive('dateformat', function (dateFilter) {
    return {
        require:'ngModel',
        link:function (scope, elm, attrs, ctrl) {

            var dateFormat = attrs['date'] || 'dd/MM/yyyy';

            ctrl.$formatters.unshift(function (modelValue) {
                return dateFilter(modelValue, dateFormat);
            });
        }
    };
});